export default __webpack_public_path__ + "static/media/insomniac_white.87c78c04.svg";